import React, { useEffect, useState } from 'react';
import {
  Grid,
  Typography,
  Box,
  Container,
  Card,
  CardContent,
  Button,
} from '@mui/material';
import Image from 'next/image';
import imgLoader from '../../../../../imgloader';
import styles from './MainBenefitsSection.module.scss';
import { mainBenefitsContent } from '../../../../../commons/Constants/MainBenefitsNewProd';
import { ContainedButton } from '../../../../../commons/hoc';
import { useRouter } from 'next/router';
import { useAppSelector } from '../../../../../src/app/hooks';
import { ProductsCategory } from '../../../../../config';
import MiniProductCard from '../../../../MiniProductCard/MiniProductCard';
import { useResponsive } from '../../../../../commons/hooks';

export default function MainBenefitsSection({ id, productType }) {
  const isTabletOrMobile = useResponsive('only', 'lg');
  const Router = useRouter();

  const selectedVariantFromRedux = useAppSelector(
    (state) => state.user.selectedVariantData
  );
  const variantFromQuery = Router.query.variant;
  const [selectedVariant, setSelectedVariant] = useState('DK2');

  useEffect(() => {
    const normalized =
      (variantFromQuery || selectedVariantFromRedux)?.replace('D_', 'D') ||
      'DK2';
    setSelectedVariant(normalized);
  }, [variantFromQuery, selectedVariantFromRedux]);

  const variantKey = [
    ProductsCategory.VITAMIN_D_K2,
    ProductsCategory.VITAMIN_D_K5,
  ].includes(productType)
    ? selectedVariant
    : productType;

  const productContent = mainBenefitsContent[variantKey];
  if (!productContent) {
    console.warn('Missing productContent for:', variantKey);
    return null;
  }

  const {
    label,
    heading,
    benefits,
    image,
    ctaImage,
    ctaText,
    ctaSubText,
    buttonText,
    gradientType,
  } = productContent;

  return (
    <div className={styles.mainBenefitsWrapper} id={id}>
      <Container maxWidth="xl" className={styles.container}>
        <Grid
          container
          display={'flex'}
          alignItems="center"
          className={styles.mainBenefitsGrid}
        >
          {/* LEFT IMAGE */}
          <Grid item xs={12} md={6}>
            <Box className={styles.imageWrapper}>
              <Image
                src={image}
                alt="Main Benefits"
                loader={imgLoader}
                layout="fill"
                objectFit="cover"
                placeholder="blur"
                blurDataURL={image}
                className={styles.mainImage}
              />
            </Box>
          </Grid>

          {/* RIGHT CONTENT */}
          <Grid item xs={12} md={6} className={styles.rightContent}>
            <div>
              <Typography
                variant="h5"
                color="primary.black"
                className={styles.label}
              >
                {label}
              </Typography>

              <Typography
                variant="h2"
                color="primary.main"
                className={styles.heading}
              >
                {heading}
              </Typography>
            </div>

            <div className={styles.benefitsContainer}>
              {benefits.map((item, index) => (
                <Box key={index} className={styles.benefitItem}>
                  <Box className={styles.benefitIcon}>{item.icon}</Box>
                  <Box className={styles.benefitContent}>
                    <Typography
                      variant="p2"
                      color="primary.black"
                      className={styles.title}
                    >
                      {item.title}
                    </Typography>
                    <Typography
                      variant="p1-book"
                      color="primary.black"
                      className={styles.desc}
                    >
                      {item.desc}
                    </Typography>
                  </Box>
                </Box>
              ))}
            </div>
            <MiniProductCard
              productImg={ctaImage}
              category={ctaText}
              productName={ctaSubText}
              link="/product-page"
              gradientType={gradientType}
              isTabletOrMobile={isTabletOrMobile}
              btnText="Buy Now"
              btnType="dark"
              onButtonClick={() =>
                Router.push('#buy', undefined, {
                  shallow: true,
                  scroll: false,
                })
              }
              sx={{ marginTop: '0px', marginLeft: '0px' }}
            />
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}
